import { c as _c } from "react/compiler-runtime";
import { FlexColumn, TextBody } from "@opensea/ui-kit";
export function SwapWarningDetail(t0) {
  const $ = _c(7);
  const {
    title,
    description
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <TextBody size="xs" weight="semibold">{title}</TextBody>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = <TextBody color="text-secondary" size="xs">{description}</TextBody>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <FlexColumn className="gap-1 pt-3">{t1}{t2}</FlexColumn>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}